<template>
  <div class="new-task-input px-[4px] py-[2px]">
    <input
      v-if="editing"
      ref="inputEl"
      v-model="title"
      @keydown.enter="create"
      @keydown.escape="cancel"
      @blur="blurHandler"
      placeholder="Add a task..."
      class="new-task-input__field w-full rounded border border-gray-200 bg-white px-[8px] py-[4px] focus:border-teal-500 focus:outline-none dark:border-gray-300 dark:bg-gray-50"
    />
    <button
      v-else
      @click="startEditing"
      class="new-task-input__trigger flex items-center gap-[4px] py-[2px] text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
    >
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
      </svg>
      Add task
    </button>
  </div>
</template>

<script setup>
import { ref, nextTick } from 'vue'

const emit = defineEmits(['create'])

const editing = ref(false)
const title = ref('')
const inputEl = ref(null)

function startEditing() {
  editing.value = true
  nextTick(() => inputEl.value?.focus())
}

function create() {
  if (!title.value.trim()) return
  emit('create', { title: title.value.trim() })
  title.value = ''
  nextTick(() => inputEl.value?.focus())
}

function blurHandler() {
  setTimeout(() => {
    if (title.value.trim()) {
      create()
    } else {
      editing.value = false
      title.value = ''
    }
  }, 150)
}

function cancel() {
  editing.value = false
  title.value = ''
}
</script>

<style scoped>
.new-task-input {
  font-family: var(--font-sans), "Inter", ui-sans-serif, system-ui, sans-serif;
}
.new-task-input__field,
.new-task-input__trigger {
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
}
</style>
